import React, { CSSProperties, FunctionComponent, useEffect, useRef } from 'react';
import { AreaInput, Label } from './TextArea.style';
import ValidationError from './ValidationError';

interface Props {
  containerStyle?: CSSProperties;
  inputStyle?: CSSProperties;
  label?: string;
  name: string;
  value: string;
  onValueChange: (value: string) => void;
  error?: false | string;
  rows: number;
  placeholder?: string;
  testID?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  autoHeight?: boolean;
  borderColour?: string;
  maxLength?: number;
}

const TextArea: FunctionComponent<Props> = (props) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (props.autoHeight && inputRef.current) {
      inputRef.current.style.height = '5px';
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  }, [props.value]);

  return (
    <div style={props.containerStyle}>
      {props.label && <Label htmlFor={props.name}>{props.label}</Label>}

      <AreaInput
        ref={inputRef}
        name={props.name}
        value={props.value}
        onChange={(e) => {
          props.onValueChange(e.target.value);
        }}
        rows={props.rows}
        placeholder={props.placeholder}
        data-testid={props.testID}
        error={props.error}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        style={props.inputStyle}
        borderColour={props.borderColour}
        maxLength={props.maxLength}
        className={props.error ? 'pp-input-error' : ''}
      />

      <ValidationError error={props.error} />
    </div>
  );
};

export default TextArea;
